import {defineStore} from 'pinia'
import {client} from "@/libraries/http";

const useProfitCenterPickerStore = defineStore('profit-center-picker', {
    state: () => ({
        picked: null,
        profitCenters: null
    }),
    actions: {
        pick(picked) {
            this.picked = picked;
        },
        pickIfNull(picked) {
            if (this.picked) return;
            this.picked = picked;
        },
        load(cheetahId) {
            if (cheetahId) {
               return client.get(`/api/h5/leo-projects/${cheetahId}/profit-centers`)
                    .then(res => {
                        this.profitCenters = res.data;
                        return this.profitCenters
                    });
            } else {
                return client.get('/api/h5/profit-centers')
                    .then(res => {
                        this.profitCenters = res.data;
                        return this.profitCenters
                    });
            }
        },
        loadIfNull(cheetahId) {
            if (this.profitCenters && this.profitCenters.length > 0) {
                return Promise.resolve(this.profitCenters)
            } else {
                return this.load(cheetahId);
            }
        },
        loadAndPickedFirst(cheetahId) {
            return this.loadIfNull(cheetahId).then(profitCenters => this.pickIfNull(profitCenters?.[0]))
        },
        reset() {
            this.picked = null;
        }
    },
})

export default useProfitCenterPickerStore;
